import { ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const NIVALIZ_TRANSACTION_VOLUME_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.NIVALIZ_TRANSACTION_VOLUME_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.APPLICATION, value: Application.NIVALIZ }]
};
